/**
 * 登录后或冷启动进入 /client 前：先尽量拿到 Java Token，再拉 RBAC 权限码。
 * 失败仅打日志，不阻塞导航（由 App 内二次补拉）。
 */
import { getJavaToken, fetchPermissionCodesByType } from '@/redux/app/appSlice'

export async function bootstrapPermissionCodes (store) {
  if (!store || typeof store.dispatch !== 'function') {
    return
  }
  try {
    await store.dispatch(getJavaToken()).unwrap()
  } catch (e) {
    console.warn('[bootstrapPermissionCodes] getJavaToken 失败', e)
  }
  try {
    await store.dispatch(fetchPermissionCodesByType()).unwrap()
  } catch (e) {
    console.warn('[bootstrapPermissionCodes] fetchPermissionCodesByType 失败', e)
  }
}
